import React, { useEffect, useState } from 'react';
import './HomePage.css';
import Nav from './components/Nav';
import Hero from './components/Hero';
import Services from './components/Services';
import Work from './components/Work';
import Team from './components/Team';
import Contact from './components/Contact';
import Footer from './components/Footer';

function HomePage() {
  const [theme, setTheme] = useState(() => {
    try {
      const stored = localStorage.getItem('siju-theme');
      if (stored === 'light' || stored === 'dark') return stored;
      const prefersLight = window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches;
      return prefersLight ? 'light' : 'dark';
    } catch (e) {
      return 'dark';
    }
  });
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    try { localStorage.setItem('siju-theme', theme); } catch (e) {}
  }, [theme]);

  function toggleTheme() { setTheme((t) => (t === 'dark' ? 'light' : 'dark')); }

  return (
    <div className={`hp-root ${theme === 'light' ? 'light' : ''}`} data-theme={theme}>
      <Nav mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} theme={theme} toggleTheme={toggleTheme} />
      {/* Floating theme toggle placed at root so it's fixed to viewport */}
      <button
        className="theme-toggle"
        onClick={toggleTheme}
        aria-pressed={theme === 'light'}
        aria-label={theme === 'light' ? 'Switch to dark theme' : 'Switch to light theme'}
        title={theme === 'light' ? 'Switch to dark theme' : 'Switch to light theme'}
      >
        {theme === 'light' ? '🌞' : '🌙'}
      </button>
      <main>
        <Hero />
        <Services />
        <Work />
        <Team />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default HomePage;
